const Accordions = {
  baseStyle: {},
  variants: {
    standard: {
      allowMultiple: true,
      container: {
        border: "none",
        borderStyle: "none",
        color: "white",
        w: "100%",
      },
      button: {
        justifyContent: "center",
        pt: 8,
        pb: 8,
        as: "Link",
        bg: "Primary.800",
        color: "white",
        border: "none",
        borderRadius: "none",
        boxShadow: "none",
        width: "100%",
        _hover: {
          borderRadius: "none",
          bg: "Primary.900",
          textDecoration: "underline",
        },
        panel: {
          bg: "Primary.700",
        },
      },
    },
    dataSets: {
      allowMultiple: true,
      font: "body",
      root: {
        m: 0,
      },
      container: {
        border: "none",
        borderStyle: "none",
        color: "white",
      },
      button: {
        pl: 4,
        bg: "Primary.700",
        color: "white",
        border: "none",
        borderRadius: "none",
        boxShadow: "none",
        width: "100%",
        _hover: {
          bg: "Primary.800",
        },
      },
      panel: {
        pl: 8,
        bg: "Primary.700",
        pb: 1,
        pt: 1,
      },
    },
    permissions: {
      allowToggle: true,
      container: {
        bg: "white",
        border: "none",
        width: "100%",
        p: 0,
        borderRadius: "xl",
        boxShadow: "lg",
      },
      button: {
        p: 0,
        pl: 4,
        pr: 4,
        m: 0,
        _hover: {
          bg: "Primary.50",
          borderRadius: "lg",
        },
      },
      icon: {
        color: "Primary.500",
      },
      panel: {
        p: 0,
        pl: 4,
        pr: 4,
        pb: 1,
        mb: 2,
      },
    },
  },
}

export default Accordions
